import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import type { CardTemplate } from './types';

interface TemplateSidesPanelProps {
  template: CardTemplate;
  sides: { id: string; name: string }[];
  onChangeFront: (sideId: string | null) => void;
  onChangeBack: (sideId: string | null) => void;
}

/** Recto/verso side assignment for a template. */
export function TemplateSidesPanel({
  template,
  sides,
  onChangeFront,
  onChangeBack,
}: TemplateSidesPanelProps) {
  const { t } = useTranslation();
  const frontId = useId();
  const backId = useId();

  return (
    <div className="grid grid-cols-2 gap-3 border-t border-t-rule bg-bg px-4 py-3">
      <div>
        <label htmlFor={frontId} className="mb-1 block text-xs text-muted">
          {t('admin.templates.recto')}
        </label>
        {/* Uncontrolled, so a pick shows while its patch is in flight; keyed on
            the server value, so a reload that changes it (another admin, a
            failed patch rolled back by the refetch) remounts the select on
            the new value instead of leaving the old pick on screen. */}
        <select
          key={template.frontSideId ?? ''}
          id={frontId}
          defaultValue={template.frontSideId ?? ''}
          className="w-full px-2 py-1.5 text-xs"
          onChange={(e) => onChangeFront(e.target.value || null)}
        >
          <option value="">{t('admin.templates.noneOption')}</option>
          {sides.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor={backId} className="mb-1 block text-xs text-muted">
          {t('admin.templates.verso')}
        </label>
        <select
          key={template.backSideId ?? ''}
          id={backId}
          defaultValue={template.backSideId ?? ''}
          className="w-full px-2 py-1.5 text-xs"
          onChange={(e) => onChangeBack(e.target.value || null)}
        >
          <option value="">{t('admin.templates.noneOption')}</option>
          {sides.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
